/**
 * @param key - session storage key
 * @param removeValue - removes value from storage
 * @returns parsed value or null if value not found
 */

export const extractFromSessionStorage = <T>(key: string, removeValue = false): T | null => {
  const stringifiedValue = window.sessionStorage.getItem(key);
  if (removeValue) {
    window.sessionStorage.removeItem(key);
  }
  return stringifiedValue && JSON.parse(stringifiedValue);
};

/**
 * @param key - session storage key
 * @param removeValue - removes value from storage
 * @returns parsed value or null if value not found
 */

export const extractFromLocalStorage = <T>(key: string, removeValue = false): T | null => {
  const stringifiedValue = window.localStorage.getItem(key);
  if (removeValue) {
    window.localStorage.removeItem(key);
  }
  return stringifiedValue && JSON.parse(stringifiedValue);
};
